// extracted by mini-css-extract-plugin
module.exports = {"SocialBtn":"SocialBtn_SocialBtn__1FFex","Telegram":"SocialBtn_Telegram__2c-E2","Instagram":"SocialBtn_Instagram__2JAVM","Youtube":"SocialBtn_Youtube__2CKmg"};